<script lang="ts">
  export let style: string = "";
  export let flexBasis: string = "";
  export let justify: string | null = null;
  export let align: string | null = null;
  export let padding: string | null = null;
  export let margin: string | null = null;
  export let borderRight: boolean = false;
  export let borderBottom: boolean = false;

  if (flexBasis) {
    style += `flex-basis: ${flexBasis};`;
  }

  if (justify) {
    style += `justify-content: ${justify};`;
  }

  if (align) {
    style += `align-items: ${align};`;
  }

  if (padding) {
    style += `padding: ${padding};`;
  }

  if (margin) {
    style += `margin: ${margin};`;
  }
</script>

<div class="cell" class:borderRight class:borderBottom {style}>
  <slot />
</div>

<style>
  .cell {
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    overflow: hidden;
  }

  .borderRight {
    border-right: solid 1px var(--rekki-neutral-01);
  }
  .borderBottom {
    border-bottom: solid 1px var(--rekki-neutral-01);
  }
</style>
